<div class="form-display-container">
  <div class="form-title" *ngIf="formName">
    <h3>{{ formName }}</h3>
  </div>

  <!-- 資料來源區塊 -->
  <div class="form-fields" *ngIf="hasReferenceData()">
    <div class="reference-data-header">
      <h4><i class="fas fa-link"></i> 資料來源</h4>
    </div>
    <div class="form-field-display" *ngFor="let item of getReferenceDataArray()">
      <div class="field-label">
        <span class="label-text">{{ item.label }}</span>
      </div>
      <div class="field-value">
        <div class="text-display">{{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="form-fields">
    <div *ngFor="let field of config; trackBy: trackByFieldName" class="form-field-display">
      <div class="field-label">
        <span class="label-text">{{ field.label }}</span>
        <span *ngIf="field.required" class="required-indicator">*</span>
      </div>

      <div class="field-value" [ngSwitch]="field.type">

        <!-- 文字輸入欄位 -->
        <ng-container *ngSwitchCase="'text-input'">
          <div class="text-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 數字輸入欄位 -->
        <ng-container *ngSwitchCase="'number-input'">
          <div class="number-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 文字區域 -->
        <ng-container *ngSwitchCase="'textarea'">
          <div class="textarea-display">
            <pre>{{ getDisplayValue(getFieldValue(field.name)) }}</pre>
          </div>
        </ng-container>

        <!-- 下拉選單 -->
        <ng-container *ngSwitchCase="'select'">
          <div class="select-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 動態API下拉選單 -->
        <ng-container *ngSwitchCase="'dynamic-api-select'">
          <div class="dynamic-api-select-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 單選按鈕 -->
        <ng-container *ngSwitchCase="'radiobutton'">
          <div class="radiobutton-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 多選項目 -->
        <ng-container *ngSwitchCase="'multi-checkbox'">
          <div class="multi-checkbox-display">
            {{ getMultiCheckboxSelectedText(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 日期時間 -->
        <ng-container *ngSwitchCase="'datetime'">
          <div class="datetime-display">
            {{ formatDateTime(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 日期 -->
        <ng-container *ngSwitchCase="'date'">
          <div class="date-display">
            {{ formatDate(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 日期範圍 -->
        <ng-container *ngSwitchCase="'date-range'">
          <div class="date-range-display">
            <ng-container *ngIf="getFieldValue(field.name) && getFieldValue(field.name).startDate && getFieldValue(field.name).endDate; else emptyDateRange">
              {{ formatDateRange(getFieldValue(field.name)) }}
            </ng-container>
            <ng-template #emptyDateRange>
              <span class="no-data">{{ 'form.display.no_date_range' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 時間戳記 -->
        <ng-container *ngSwitchCase="'timestamp'">
          <div class="timestamp-display">
            {{ formatTimestamp(getFieldValue(field.name)?.value) }}
          </div>
        </ng-container>

        <!-- 地點 -->
        <ng-container *ngSwitchCase="'location'">
          <div class="location-display">
            <a [href]="getGoogleMapsUrl(getFieldValue(field.name))" target="_blank"
               class="location-link" *ngIf="getFieldValue(field.name)">
              <i class="fa-solid fa-location-dot"></i>
              <span>{{ 'form.display.view_location' | translate }}</span>
            </a>
            <span *ngIf="!getFieldValue(field.name)" class="no-data">{{ 'form.display.no_location' | translate }}</span>
          </div>
        </ng-container>

        <!-- 照片上傳 -->
        <ng-container *ngSwitchCase="'photo-upload'">
          <div class="photo-upload-display">
            <div *ngIf="parsePhotos(getFieldValue(field.name)).length > 0; else noPhotos" class="photo-gallery">
              <div *ngFor="let photo of parsePhotos(getFieldValue(field.name))" class="photo-item">
                <img [src]="photo.fileUrl" [alt]="photo.fileName"
                     class="photo-thumbnail"
                     (click)="viewImageFullSize(photo.fileUrl)">
              </div>
            </div>
            <ng-template #noPhotos>
              <span class="no-data">{{ 'form.display.no_photos' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 大頭照上傳 -->
        <ng-container *ngSwitchCase="'avatar-upload'">
          <div class="avatar-upload-display">
            <div *ngIf="getFieldValue(field.name); else noAvatar" class="avatar-container">
              <img [src]="getFieldValue(field.name).previewUrl || getFieldValue(field.name).fileUrl"
                   [alt]="'Avatar'"
                   class="avatar-image"
                   (click)="viewImageFullSize(getFieldValue(field.name).previewUrl || getFieldValue(field.name).fileUrl)">
            </div>
            <ng-template #noAvatar>
              <span class="no-data">{{ 'form.display.no_avatar' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 簽名 -->
        <ng-container *ngSwitchCase="'signature'">
          <div class="signature-display">
            <!-- 只有當有簽名資料且值不為空時才顯示 -->
            <ng-container *ngIf="hasValidSignatureData(getFieldValue(field.name))">
              <div class="signature-container">
                <!-- 顯示簽名圖片和摘要 -->
                <div class="signature-display">
                  <img [src]="getSignatureImageData(getFieldValue(field.name))"
                       alt="Signature"
                       class="signature-image"
                       [title]="getSignatureTooltip(getFieldValue(field.name))">
                  <div class="signature-info">
                    <small class="signature-summary">{{ getSignatureSummary(getFieldValue(field.name)) }}</small>
                    <small class="signed-date" *ngIf="getSignatureDate(getFieldValue(field.name))">
                      {{ getSignatureDate(getFieldValue(field.name)) }}
                    </small>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- 無簽名資料時顯示 -->
            <ng-container *ngIf="!hasValidSignatureData(getFieldValue(field.name))">
              <span class="no-data">{{ 'form.display.no_signature' | translate }}</span>
            </ng-container>
          </div>
        </ng-container>

        <!-- 檔案上傳管理 -->
        <ng-container *ngSwitchCase="'file-upload-manager'">
          <div class="file-upload-manager-display">
            <div *ngIf="hasFiles(field); else noFiles" class="file-list">
              <div *ngFor="let file of getFiles(field)" class="file-item">
                <button class="file-view-btn" (click)="viewFile(file)">
                  <i class="fas fa-file"></i>
                  <span>{{ file.name }}</span>
                </button>
              </div>
            </div>
            <ng-template #noFiles>
              <span class="no-data">{{ 'form.display.no_files' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 檔案顯示 -->
        <ng-container *ngSwitchCase="'file-display'">
          <div class="file-display-display">
            <div *ngIf="field.files && field.files.length > 0; else noFiles" class="file-list">
              <div *ngFor="let file of field.files" class="file-item">
                <button class="file-view-btn" (click)="viewFile(file)">
                  <i class="fas fa-file"></i>
                  <span>{{ file.fileName || 'Unknown File' }}</span>
                </button>
              </div>
            </div>
            <ng-template #noFiles>
              <span class="no-data">{{ 'form.display.no_files' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 部門選擇器 -->
        <ng-container *ngSwitchCase="'department-selector'">
          <div class="department-selector-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 人員選擇器 -->
        <ng-container *ngSwitchCase="'personnel-selector'">
          <div class="personnel-selector-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 標籤 -->
        <ng-container *ngSwitchCase="'tags'">
          <div class="tags-display">
            {{ getMultiCheckboxSelectedText(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 簽核流程 -->
        <ng-container *ngSwitchCase="'approval-flow'">
          <div class="approval-flow-display">
            <app-approval-flow-display
              [steps]="convertToApprovalFlowSteps(field)"
              [compact]="false"
              [showLabels]="true"
              [enableStepClick]="true"
              [currentUserId]="getCurrentUserId()"
              [id]="recordId"
              [formId]="formid"
              [formName]="formName"
              [approvalFlow]="getApprovalFlowData(field)"
              [deleted]="formData?.deleted"
              (approvalComplete)="onApprovalComplete($event)">
            </app-approval-flow-display>
          </div>
        </ng-container>

        <!-- 承認人員選擇器 -->
        <ng-container *ngSwitchCase="'approval-personnel-selector'">
          <div class="approval-personnel-selector-display">
            <app-approval-flow-display
              [steps]="convertToApprovalPersonnelSteps(field)"
              [compact]="false"
              [showLabels]="true"
              [enableStepClick]="true"
              [currentUserId]="getCurrentUserId()"
              [id]="recordId"
              [formId]="formid"
              [formName]="formName"
              [approvalFlow]="getApprovalPersonnelData(field)"
              (approvalComplete)="onApprovalComplete($event)">
            </app-approval-flow-display>
          </div>
        </ng-container>

        <!-- 段落 -->
        <ng-container *ngSwitchCase="'paragraph'">
          <div class="paragraph-display">
            <div [innerHTML]="field.content"
                 [style.text-align]="field.textAlign || 'left'">
            </div>
          </div>
        </ng-container>

        <!-- 富文本顯示 -->
        <ng-container *ngSwitchCase="'rich-text-display'">
          <div class="rich-text-display">
            <div [innerHTML]="field.content"
                 [style.text-align]="field.textAlign || 'left'">
            </div>
          </div>
        </ng-container>

        <!-- 填空欄位 -->
        <ng-container *ngSwitchCase="'fill-in'">
          <div class="fill-in-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 動態API表格 -->
        <ng-container *ngSwitchCase="'dynamic-api-table'">
          <div class="dynamic-api-table-display">
            <!-- 表格資訊摘要 -->
            <div class="table-info">
              <i class="fas fa-table"></i>
              <span>{{ getDynamicApiTableCount(getFieldValue(field.name)) }} {{ 'common.records' | translate }}</span>
            </div>

            <!-- 直接顯示表格內容 -->
            <div class="dynamic-api-table-content" *ngIf="getDynamicApiTableData(getFieldValue(field.name)).length > 0">
              <div class="table-container">
                <table class="table">
                  <thead>
                    <tr>
                      <th *ngFor="let column of getDynamicApiTableColumns(getFieldValue(field.name))">
                        {{ getColumnDisplayName(column) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getDynamicApiTableData(getFieldValue(field.name))">
                      <td *ngFor="let column of getDynamicApiTableColumns(getFieldValue(field.name))">
                        {{ getDisplayValueForTableCell(item[column]) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 無資料時的提示 -->
            <div class="no-data-message" *ngIf="getDynamicApiTableData(getFieldValue(field.name)).length === 0">
              <i class="fas fa-info-circle"></i>
              <span>{{ 'form.list.no_data_display' | translate }}</span>
            </div>
          </div>
        </ng-container>

        <!-- 子表單關聯 -->
        <ng-container *ngSwitchCase="'subform-relation'">
          <div class="subform-relation-display">
            <div class="subform-info">
              <i class="fas fa-link"></i>
              <span>{{ 'form.display.subform_relation' | translate }}</span>
            </div>
            <div class="subform-count">
              <!-- 🔑 優化：直接使用 Map 取值，避免重複呼叫函數 -->
              <ng-container *ngIf="getFieldValue(field.name) as formId">
                <!-- 有資料時顯示可點擊的筆數 -->
                <span *ngIf="(subformCountMap.get(formId) || 0) > 0"
                      class="count-badge clickable"
                      (click)="openSubformInNewTab(formId)"
                      [title]="'點擊查看詳細資料' | translate">
                  {{ subformCountMap.get(formId) }} {{ 'common.records' | translate }}
                  <i class="fas fa-external-link-alt external-link-icon"></i>
                </span>
                <!-- 無資料時顯示紅色文字 -->
                <span *ngIf="(subformCountMap.get(formId) || 0) === 0"
                      class="no-data-text">
                  尚未填寫資料
                </span>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- 必要文件上傳 -->
        <ng-container *ngSwitchCase="'required-document-upload'">
          <div class="required-document-upload-display">
            <div *ngIf="hasRequiredDocument(getFieldValue(field.name)); else noRequiredFile" class="required-document-display">
              <div class="file-download-section">
                <button type="button"
                        class="btn btn-sm btn-outline-primary file-download-btn"
                        (click)="viewFile(getRequiredDocumentFile(getFieldValue(field.name)))"
                        [title]="getRequiredDocumentFile(getFieldValue(field.name))?.name">
                  <i class="fas fa-download"></i>
                  {{ 'common.download_file' | translate }}
                </button>
              </div>
              <div class="file-info" *ngIf="getRequiredDocumentFile(getFieldValue(field.name))?.name">
                <small class="file-name text-muted">{{ getRequiredDocumentFile(getFieldValue(field.name))?.name }}</small>
              </div>
              <div class="ai-response-section" *ngIf="getRequiredDocumentAIResponse(getFieldValue(field.name))">
                <small class="ai-response-text">{{ getRequiredDocumentAIResponse(getFieldValue(field.name)) }}</small>
              </div>
            </div>
            <ng-template #noRequiredFile>
              <span class="no-data">{{ 'form.display.no_required_documents' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 自動編號 -->
        <ng-container *ngSwitchCase="'auto-numbering'">
          <div class="auto-numbering-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

        <!-- 音訊錄製 -->
        <ng-container *ngSwitchCase="'audio-recorder'">
          <div class="audio-recorder-display">
            <div *ngIf="getFieldValue(field.name); else noAudio" class="audio-container">
              <audio [src]="getFieldValue(field.name)" controls></audio>
            </div>
            <ng-template #noAudio>
              <span class="no-data">{{ 'form.display.no_audio' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 影片播放器 -->
        <ng-container *ngSwitchCase="'video-player'">
          <div class="video-player-display">
            <div *ngIf="getFieldValue(field.name); else noVideo" class="video-container">
              <video [src]="getFieldValue(field.name)" controls></video>
            </div>
            <ng-template #noVideo>
              <span class="no-data">{{ 'form.display.no_video' | translate }}</span>
            </ng-template>
          </div>
        </ng-container>

        <!-- 會議簽名收集 -->
        <ng-container *ngSwitchCase="'meeting-signature-collection'">
          <div class="meeting-signature-collection-display">
            <div class="signature-collection-info">
              <i class="fas fa-users"></i>
              <span>{{ 'form.display.meeting_signatures' | translate }}</span>
            </div>
            <div class="signature-collection-value">
              {{ getMeetingSignatureCollectionText(getFieldValue(field.name)) }}
            </div>
          </div>
        </ng-container>

        <!-- 風險評估矩陣 -->
        <ng-container *ngSwitchCase="'risk-assessment-matrix'">
          <div class="risk-assessment-matrix-display">
            <div class="risk-assessment-info">
              <i class="fas fa-chart-bar"></i>
              <span>{{ 'form.display.risk_assessment' | translate }}</span>
            </div>
            <div class="risk-assessment-value">
              {{ getRiskAssessmentMatrixText(getFieldValue(field.name)) }}
            </div>
          </div>
        </ng-container>

        <!-- 預設顯示 -->
        <ng-container *ngSwitchDefault>
          <div class="default-display">
            {{ getDisplayValue(getFieldValue(field.name)) }}
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>
